












import { defineComponent, onMounted, ref } from "@vue/composition-api";
import BaseIcon from "@/components/BaseIcon";

export default defineComponent({
  name: "BaseDownloadButton",
  components: { BaseIcon },
  props: {
    fontSize: { type: [String, Number], default: 24 },
    color: { type: String, default: "var(--palette-bg)" },
    url: { type: String, default: "" },
    name: { type: String, default: "file" },
  },
  setup(props) {
    const saveUrl = ref("");

    const setSaveUrl = async () => {
      const response = await fetch(props.url);
      const blob = await response.blob();
      saveUrl.value = URL.createObjectURL(blob);
    };

    onMounted(() => {
      setSaveUrl();
    });

    return { saveUrl };
  },
});
